export const CodingAutomatorMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill={'none'}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3332 15L18.3332 10L13.3332 5M6.6665 5L1.6665 10L6.6665 15"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
